import { gql } from '@apollo/client';

export const GET_WATERLINK_SITE_VISIT_TYPES = gql`
  query GetWaterlinkSiteVisitTypes {
    getWaterlinkSiteVisitTypes {
      code
      name
    }
  }
`;

export const GET_ALL_EPA_SITE_VISIT_TYPES = gql`
  query GetAllEpaSiteVisitTypes {
    getAllEpaSiteVisitTypes {
      code
      name
    }
  }
`;

export const ADD_WATERLINK_SITE_VISIT_TYPE = gql`
  mutation AddWaterlinkSiteVisitType($input: AddWaterlinkSiteVisitTypeInput!) {
    addWaterlinkSiteVisitType(input: $input) {
      code
      name
    }
  }
`;